// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEmojiPlus24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5ZM14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5ZM16.41 13.89C16.06 13.67 15.59 13.78 15.38 14.13C14.64 15.3 13.38 16 12 16C10.62 16 9.36 15.3 8.62 14.12C8.4 13.77 7.94 13.66 7.59 13.88C7.24 14.1 7.13 14.56 7.35 14.91C8.37 16.54 10.1 17.5 12 17.5C13.9 17.5 15.63 16.53 16.65 14.92C16.87 14.57 16.76 14.11 16.41 13.89Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C12.8636 20.25 13.6948 20.1176 14.4753 19.8724C14.8704 19.7483 15.2914 19.9681 15.4155 20.3632C15.5397 20.7584 15.3199 21.1794 14.9247 21.3035C14.0005 21.5938 13.0178 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 13.0178 21.5938 14.0005 21.3035 14.9247C21.1794 15.3199 20.7584 15.5397 20.3632 15.4155C19.9681 15.2914 19.7483 14.8704 19.8724 14.4753C20.1176 13.6948 20.25 12.8636 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.75 17C20.75 16.5858 20.4142 16.25 20 16.25C19.5858 16.25 19.25 16.5858 19.25 17V19.25H17C16.5858 19.25 16.25 19.5858 16.25 20C16.25 20.4142 16.5858 20.75 17 20.75H19.25V23C19.25 23.4142 19.5858 23.75 20 23.75C20.4142 23.75 20.75 23.4142 20.75 23V20.75H23C23.4142 20.75 23.75 20.4142 23.75 20C23.75 19.5858 23.4142 19.25 23 19.25H20.75V17Z"
				/>
			</Svg>
		);
	}
);
SvgEmojiPlus24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEmojiPlus24;
